import React from 'react';
import { useAppContext } from '../shared/AppContext';
import { useSPSyncController } from './hooks/useSPSyncController';
import SPSyncView from './components/SPSyncView';

const SPSync: React.FC = () => {
    const app = useAppContext();
    const ctrl = useSPSyncController();

    if (!app.loginUser) {
        return <div></div>;
    }

    if (!ctrl.isSuper) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Access Denied</h4>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return <SPSyncView {...ctrl} />;
};

export default SPSync;
